export default "__VITE_ASSET__9cdb2d09__"